// Automated imports for routes
let routes = []
let requireRouter = require.context('./routers/', true, /\w+\.js$/)
requireRouter.keys().forEach(filename => {
  routes = [...routes, ...requireRouter(filename).default]
})

export { routes }
